const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://api.qhpccc.cgis.asia/",
    // api: "https://htpccc-api.cgis.asia/",
  },
  production: {
    api: "https://api.qhpccc.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
